import { Add } from "@mui/icons-material";
import { Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { tableUseStyle } from "../../etc/tableusestyle";
import { DataGridPremium, GridFilterModel } from "@mui/x-data-grid-premium";
import NewTodoModal from "./newtodomodal";
import NewTodoModalForRegular from "./newtodomodalforregular";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Select, Option } from '@mui/joy';
import NewKakaoMessageModalRegular from "./newkakaomessagemodalregular";
import { addZeroIfOne } from "../../etc/etcfunctions";
import totalLocationData from "../../../../../data/locationdata";
import NewIotModalRegular from "./newiotmodalregular";
import { englishLocationToKorean } from "../../../../../data/locationFuntion";


const RegularIot: React.FC<any> = (props) => {

    const [open, setOpen] = useState<boolean>(false);
    const [columns, setColumns] = useState<any>([
        {
            field: "active",
            headerName: "활성",
            width: 80,
        },
        {
            field: "regular",
            headerName: "주기",
            width: 80,
        },
        {
            field: "time",
            headerName: "상세날짜",
            width: 100
        },
        {
            field: "hourminute",
            headerName: "시간",
            width: 100
        },
        {
            field: "direction",
            headerName: "방향",
            width: 100
        },
        {
            field: "projectName",
            headerName: "지점",
            width: 250
        },
        {
            field: "author",
            headerName: "작성자",
            width: 100
        },
        {
            field: "createdAt",
            headerName: "작성일",
            width: 100
        }
    ]);
    const [rows, setRows] = useState<any>([]);
    const classes = tableUseStyle();
    const [update, setUpdate] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
    const [alignment, setAlignment] = useState("전체");
    const [alignment2, setAlignment2] = useState("active");
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            {
                id: 1,
                field: "projectName",
                operator: "contains",
                value: ""
            },
            {
                id : 2,
                field: "active",
                operator: "equals",
                value: "O"
            }
        ],
    });

    useEffect(() => {

        console.log("gogogo");


        getRegularTodos();

    }, [update]);

    const getRegularTodos = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/todoist/getRegularWindows");

            console.log(result);

            const data = result.data;

            const newRows: any = [];

            console.log(3);

            data.forEach((each: any) => {

                const oneRow: any = {};

                oneRow.id = each.id;

                oneRow.projectName = englishLocationToKorean(each.selectedProjectId);
                oneRow.active = each.active ? "O" : "X";

                oneRow.regular = each.regularType === "daily" ? "매일" : each.regularType === "weekly" ? "매주" : each.regularType === "monthly" ? "매월" : "매년";

                if (each.regularType === "weekly") {
                    var koreanDayString = "";

                    switch (each.dayString) {
                        case "mon":
                            koreanDayString = "월요일";
                            break;
                        case "tue":
                            koreanDayString = "화요일";
                            break;
                        case "wed":
                            koreanDayString = "수요일";
                            break;
                        case "thu":
                            koreanDayString = "목요일";
                            break;
                        case "fri":
                            koreanDayString = "금요일";
                            break;
                        case "sat":
                            koreanDayString = "토요일";
                            break;
                        case "sun":
                            koreanDayString = "일요일";
                            break;
                    }

                    oneRow.time = koreanDayString
                }

                if (each.regularType === "monthly") {
                    oneRow.time = `${each.dateString}일`;
                }

                oneRow.hourminute = `${addZeroIfOne(each.selectedHours)}:${addZeroIfOne(each.selectedMinutes)}`;

                oneRow.calctime = 60 * each.selectedHours + each.selectedMinutes;

                oneRow.author = each.name;

                oneRow.direction = each.direction;

                const createdAtDate = new Date(each.createdAt);

                oneRow.createdAt = `${createdAtDate.getFullYear()}-${createdAtDate.getMonth() + 1}-${createdAtDate.getDate()}`;

                newRows.push(oneRow);

            })

            //time으로 오름차순 정렬
            newRows.sort((a: any, b: any) => {
                return a.calctime - b.calctime;
            })

            console.log(newRows);

            setRows([...newRows]);

            setLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const letsUpdate = () => {
        setUpdate(Math.random());
    }

    const letsDeactivate = async () => {

        if (!window.confirm("정말 비활성화 하시겠습니까?")) return;

        try {

            setLoading(true);

            await postFetch("/dashboard/todoist/deactivateRegularWindows", {
                id: selectedRowId
            });

            setLoading(false);

            letsUpdate();

        } catch (e) {
            console.log(e);
        }

    }

    const letsDelte = async () => {

        if (!window.confirm("정말 삭제하시겠습니까?")) return;

        try {

            setLoading(true);

            await postFetch("/dashboard/todoist/deleteRegularWindows", {
                id: selectedRowId
            });

            setLoading(false);

            letsUpdate();

        } catch (e) {
            console.log(e);
        }

    }

    const handleChange = (event: any, newAlignment: string | null) => {

        if (!newAlignment) return;

        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((item: any) => {

            if (item.field === "projectName") {
                item.value = newAlignment;
            }

            if (newAlignment === "전체" && item.field === "projectName") {
                item.value = "";
            }

        })

        setFilterModel({ ...newFilterModel });

        setAlignment(newAlignment);

    };

    const handleChange2 = (event: any, newAlignment: string | null) => {
        if (!newAlignment) return;

        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((item: any) => {

            if (item.field === "active") {
                
                if(newAlignment === "active") {
                    item.value = "O";
                }
                else if(newAlignment === "inactive") {
                    item.value = "X";
                }

            }

        })

        setFilterModel({ ...newFilterModel });
        setAlignment2(newAlignment);

    }




    return (
        <div style={{
            width: "96%"
        }}>
            <div style={{
                fontFamily: "Apple_B",
                marginTop: "50px",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
            }}>
                <div style={{
                    marginRight: "18px"
                }}>
                    반복 창문 작동 등록
                </div>
                <div>
                    <Button variant="solid" startDecorator={<Add />} size="sm" onClick={(e: any) => { setOpen(true); }}>
                        추가하기
                    </Button>
                </div>
            </div>
            <div style={{
                height: "30px"
            }}></div>
            <div className={classes.root} style={{ height: "500px", width: "100%" }}>
                <div style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "12px"
                }}>
                    <div style={{ marginBottom: "18px" }}>
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment2}
                            exclusive
                            onChange={handleChange2}
                            sx={{
                                marginRight: "10px"
                            }}
                        >
                            <ToggleButton value="active">활성</ToggleButton>
                            <ToggleButton value="inactive">비활성</ToggleButton>
                        </ToggleButtonGroup>
                        
                        <ToggleButtonGroup
                            color="primary"
                            value={alignment}
                            exclusive
                            onChange={handleChange}
                        >
                            {
                                props.user && totalLocationData.filter((each) => each.academy.includes(props.user.academy)).map((each, index) => {


                                    return (
                                        <ToggleButton value={each.korean} key={index}>{each.korean}</ToggleButton>
                                    )
                                })
                            }
                        </ToggleButtonGroup>
                    </div>
                    <div>
                    <Button variant="soft" color="danger"
                            disabled={!selectedRowId}
                            onClick={letsDeactivate}
                            sx={{
                                marginRight: "10px"
                            }}
                        >
                            비활성화
                        </Button>
                        
                        <Button variant="soft" color="danger"
                            disabled={!selectedRowId}
                            onClick={letsDelte}
                        >
                            삭제하기
                        </Button>
                    </div>

                </div>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density="compact"
                    loading={loading}
                    onRowClick={(e: any) => {
                        console.log(e.id);
                        setSelectedRowId(e.id);
                    }}
                    filterModel={filterModel}
                    onFilterModelChange={(model) => {
                        setFilterModel(model);
                    }}
                />
            </div>

            <NewIotModalRegular open={open} handleClose={() => { setOpen(false); }} apiKey={props.apiKey}
                projects={props.projects} letsUpdate={letsUpdate}
                user={props.user}
            />
        </div>
    )
}

export default RegularIot;